import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';
import qs from 'qs';
import { browserHistory } from 'react-router';

class VocabularyThemeListService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      vocabularyThemes: [],
      filter: '',
      pagination: {
        current: 1,
        total: 0,
        pageSize: 15,
      },
    });
  }

  init = action(() => {
    const params = qs.parse(window.location.search.substring(1));
    if (params.page) {
      this.pagination.current = parseInt(params.page);
    }
    this.vocabularyThemes = [];
    this.load(this.pagination);
  });

  load = action((page) => {
    if (page && page.current) {
      this.pagination.current = page.current;
    } else {
      this.pagination.current = 1;
    }

    this.fetch
      .fetch({
        apiVersion: 'v3',
        url: '/vocabulary-themes',
        query: {
          page: this.pagination.current,
          size: this.pagination.pageSize,
          ...(this.filter && {
            name: {
              $regex: this.filter,
              $options: 'i',
            },
          }),
        },
      })
      .then(() => {
        if (this.fetch.data && this.fetch.data.docs) {
          this.pagination.total = this.fetch.data.total;
          this.vocabularyThemes = this.fetch.data.docs;
          const params = qs.parse(window.location.search.substring(1));
          params.page = this.pagination.current;
          browserHistory.replace(`${window.location.pathname}?${qs.stringify(params)}`);
        } else {
          this.vocabularyThemes = [];
        }
      });
  });

  handleFilterChange = action((value) => {
    this.filter = value;
    this.load();
  });

  handleRestore = action((vocabularyTheme) => {
    ConfirmationDialogService.show(
      'Restore Vocabulary Theme',
      `You are about to enable the Vocabulary Theme "${vocabularyTheme.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            apiVersion: 'v3',
            url: `/vocabulary-themes/${vocabularyTheme.id}/restore`,
            method: 'patch',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(
                `Vocabulary Theme "${vocabularyTheme.name}" restored successfully.`,
                'success'
              );
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });

  handleDisable = action((vocabularyTheme) => {
    ConfirmationDialogService.show(
      'Delete Vocabulary Theme',
      `You are about to disable the Vocabulary Theme "${vocabularyTheme.name}", Do you want to continue ?`,
      () => {
        this.fetch
          .fetch({
            apiVersion: 'v3',
            url: `/vocabulary-themes/${vocabularyTheme.id}/disable`,
            method: 'patch',
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification(
                `Vocabulary Theme "${vocabularyTheme.name}" disabled successfully.`,
                'success'
              );
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const vocabularyListService = new VocabularyThemeListService();

export default vocabularyListService;
